import { OnboardingStep } from '@/entities/onboarding-status';
import cognitoConfig from '../config/cognito';
import { http } from '../http';

export type LoginWithOtpResponse = {
	access_token: string;
	expires_in: number;
	token_type: string;
	id_token: string;
	// Raw PROCESS status (e.g. data_validation), not a wizard step.
	onboarding_step: string | null;
	onboarding_process_ulid: string | null;
	next_step?: OnboardingStep | null;
};

export const loginWithOtp = async (
	email: string,
	session: string,
	otp: string,
	userId: string,
) => {
	const signupResponse = await http.post<LoginWithOtpResponse>(
		'auth/login-confirmation',
		{
			email,
			client_id: cognitoConfig.cognitoClient,
			user_id: userId,
			session,
			method: 'email',
			otp,
		},
		true,
	);
	return signupResponse;
};
